import { createFileRoute } from '@tanstack/react-router'
import { ComponentDemos } from './-components/dev-resources/component-demos'

export const Route = createFileRoute('/_app/dev-resources/components')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <section className="flex flex-col gap-6">
      <h2 className="text-xl font-semibold">Component demos</h2>
      <ComponentDemos />
    </section>
  )
}
